<script>
  import Mainvisual from "./Mainvisual.svelte";
  import Feature from "./Feature.svelte";
  import Account from "./Account.svelte";
  import About from "./About.svelte";
  import News from "./News.svelte";
  import Faq from "./Faq.svelte";
</script>

<Mainvisual />
<Feature />
<section class="owd-biz-section:spacing-bottom">
  <cta-biz size="small"
  click_id_open="pc-cta1-business"
  click_id_login="pc-cta1-business" url_login="https://businessaccount.minna-no-ginko.com/corporation-account/enterprise_id/00000009/clin" blank_login="_black"
  ></cta-biz>
</section>
<Account />
<section class="owd-biz-section:spacing-bottom">
  <cta-biz size="small"
  click_id_open="pc-cta2-business"
  click_id_login="pc-cta2-business" url_login="https://businessaccount.minna-no-ginko.com/corporation-account/enterprise_id/00000009/clin" blank_login="_black"
  ></cta-biz>
</section>
<About />
<News />
<Faq />
<cta-biz title_login='法人インターネット<br class=\"show:pc\">バイキングログイン' url_login='https://eib.minna-no-ginko.com/'></cta-biz>